export enum CityType {
    Kolarovo = 'kolarovo',
    NoveZamky = 'novezamky',
    Komarno = 'komarno',
}
